import { Shield, Award, Users, Target } from 'lucide-react';
import { aboutContent, testimonials } from '../data/mock';

const About = () => {
  return (
    <div className="bg-black text-white min-h-screen pt-32 pb-20">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h1 className="font-display text-5xl md:text-6xl font-bold text-red-500 mb-6 uppercase">
            About EWS Productions
          </h1>
          <p className="text-xl text-gray-300 leading-relaxed">
            Creating cinematic environments where artistic vision meets technical excellence
          </p>
        </div>

        {/* Mission */}
        <div className="max-w-4xl mx-auto mb-20">
          <div className="bg-zinc-900 rounded-lg p-8 lg:p-12 border border-red-900/20">
            <h2 className="text-3xl font-semibold text-white mb-6">Our Mission</h2>
            <p className="text-lg text-gray-300 leading-relaxed">
              {aboutContent.mission}
            </p>
          </div>
        </div>

        {/* Values */}
        <div className="max-w-6xl mx-auto mb-20">
          <h2 className="text-3xl font-semibold text-white mb-12 text-center">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {aboutContent.values.map((value, index) => {
              const icons = [Award, Shield, Users, Target, Shield];
              const IconComponent = icons[index];
              return (
                <div key={index} className="text-center">
                  <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 rounded-full bg-red-600/10 flex items-center justify-center">
                      <IconComponent className="text-red-500" size={28} />
                    </div>
                  </div>
                  <h3 className="text-lg font-semibold text-white">{value}</h3>
                </div>
              );
            })}
          </div>
        </div>

        {/* Inspiration */}
        <div className="max-w-6xl mx-auto mb-20">
          <h2 className="text-3xl font-semibold text-white mb-8 text-center">Inspired By</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-zinc-900 rounded-lg p-8 border border-red-900/20">
              <h3 className="text-xl font-semibold text-red-500 mb-4">Noir Cinema</h3>
              <p className="text-gray-400 leading-relaxed">
                Dark, atmospheric storytelling with dramatic lighting and shadowy aesthetics that create mood and tension.
              </p>
            </div>
            <div className="bg-zinc-900 rounded-lg p-8 border border-red-900/20">
              <h3 className="text-xl font-semibold text-red-500 mb-4">Underground Culture</h3>
              <p className="text-gray-400 leading-relaxed">
                Alternative creative movements that challenge conventions and push boundaries with artistic integrity.
              </p>
            </div>
            <div className="bg-zinc-900 rounded-lg p-8 border border-red-900/20">
              <h3 className="text-xl font-semibold text-red-500 mb-4">Avant-Garde Fashion</h3>
              <p className="text-gray-400 leading-relaxed">
                Editorial photography and high-fashion design that experiments with bold visual statements and conceptual art.
              </p>
            </div>
          </div>
        </div>

        {/* Testimonials */}
        <div className="max-w-6xl mx-auto mb-20">
          <h2 className="text-3xl font-semibold text-white mb-12 text-center">What Clients Say</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="bg-zinc-900 rounded-lg p-8 border border-red-900/20">
                <div className="mb-4">
                  <span className="inline-block px-4 py-1 rounded-full bg-red-600/10 text-red-500 text-xs font-mono tracking-wider uppercase">
                    {testimonial.category}
                  </span>
                </div>
                <p className="text-gray-300 italic mb-6 leading-relaxed">
                  "{testimonial.quote}"
                </p>
                <p className="text-gray-500 text-sm font-semibold">
                  {testimonial.author}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Commitment */}
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-zinc-900 rounded-lg p-8 lg:p-12 border border-red-900/20">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 rounded-full bg-red-600/10 flex items-center justify-center">
                <Shield className="text-red-500" size={36} />
              </div>
            </div>
            <h2 className="text-3xl font-semibold text-white mb-3">Our Commitment</h2>
            <p className="text-lg text-gray-300 leading-relaxed">
              We are committed to maintaining the highest standards of professionalism, artistic integrity, and respect for all creative collaborators. Every project benefits from our experience in studio management, production excellence, and a consent-first approach that ensures a safe, controlled environment for ambitious creative work.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;